import { Insurance } from "@/domain/entities/Insurance";
import formatPrice from "@/app/infrastructures/misc/common-library/FormatPrice";
import { convertDecimalWithComma } from "@/app/infrastructures/misc/Utils";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";

export const maxLengthWeight = (value: any) => {
  if (Number(value) >= 150) return 3;
  else if (Number(value.split(",")[0]) < 10) return 4;
  else if (Number(value.split(",")[0]) < 100) return 5;
  return 6;
};

export const bannerInfo = (data: Insurance): any => ({
  exceeds5Million: `<p><strong>Harga barang</strong> melebihi <strong>5 juta, asuransi otomatis terpilih. Agen dapat tambahan income ${formatPrice(
    data.commisionPos
  )} </strong> & customer dapat proteksi hingga <strong>150 Juta!</strong></p>`,
  deliveryNonInsurance: `<p><strong>Agen bisa dapat tambahan income ${convertDecimalWithComma(
    data.viewCommissionPos,
    2
  )}% dari premi,</strong> Yuk tawarkan customer pakai <strong>asuransi</strong> agar barang terproteksi <strong>150 Juta!</strong></p>`,
  deliveryInsurance: `<p><strong>Agen bisa dapat tambahan income ${formatPrice(
    data.commisionPos
  )} dari premi,</strong> Yuk tawarkan customer pakai <strong>asuransi seharga ${formatPrice(
    data.insuranceCost + data.insuranceAdminFee
  )}</strong> agar barang terproteksi <strong>150 Juta!</strong></p>`,
  codOrDfod: `<p><strong>Pengiriman COD sudah tercover asuransi!</strong> Barang customer terproteksi asuransi hingga <strong>150 Juta!</strong></p>`
});

export const fraudError = () => {
  return {
    isLimited: BookingController.phoneCheckerData?.status === "limited",
    isSuspected: BookingController.phoneCheckerData?.status === "suspected",
    isBlacklist: BookingController.phoneCheckerData.isBlacklist,
    isPhoneNumberFraudLimited:
      BookingController.phoneCheckerData.status === "limited" &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled()
  };
};

export const utilsAddShipmentDestination = () => {
  return {
    isFreeTradeZone: AccountController.isFreeTradeZone,
    isErrorSpesificRate: ShipmentBookingController.errorSpesificByRate,
    isErrorAdd: ShipmentBookingController.isError,
    errorCause: ShipmentBookingController.isErrorCause,
    isErrorCity: BookingController.manualBooking.destinationCity?.status === "INACTIVE" ||
      BookingController.manualBooking.originCity?.status === "INACTIVE",
    titleErrorspesification: BookingController.titleErrorspesification,
    openSuccess: ShipmentBookingController.showModalSuccess,
    messageSuccess: ShipmentBookingController.messageSuccess,
    detailClientID: ClientManagementController.detailClientManagement,
    isFtzAccount: AccountController.accountData.account_location?.city_free_trade_zone ===
      "yes",
    maxAddressLength: FlagsMedusa.config_max_address.getValue(),
    discountFavoritePercentage: BookingController.shipmentIdList.data[0].discountFavoritePercentage
  }
}


